import React, { useState, useEffect } from 'react';

import AnimatedRocket from './AnimatedRocket';

export function LoadingState({
	isLoading,
	loadingMessage = 'Doing Rocket Science...',
	successMessage = 'Success!',
	showSuccess = false,
	className = ''
}) {
	const [animatedProgress, setAnimatedProgress] = useState(0);

	useEffect(() => {
		if (isLoading) {
			setAnimatedProgress(0);
			const interval = setInterval(() => {
				setAnimatedProgress((prev) => {
					if (prev < 95) {
						return prev + 1;
					}
					return prev;
				});
			}, 500);

			return () => clearInterval(interval);
		} else if (showSuccess) {
			setAnimatedProgress(100);
		}
	}, [isLoading, showSuccess]);

	if (!isLoading && !showSuccess) return null;

	return (
		<div className={`bg-white d-flex justify-content-center align-items-center ${className}`}>
			<div className="text-center text-dark pt-4">
				<div>
					<div className="pb-4">
						<AnimatedRocket />
					</div>

					<div className="d-flex align-items-center justify-content-center gap-2 position-relative mb-3">
						<div className="spinner-container">
							<div className="spinner-border-tapered"></div>
							<div className="spinner-text">{animatedProgress}%</div>
						</div>
					</div>
					<div className="pb-2 d-flex align-items-center justify-content-center gap-2">
						<span className="font-weight-bold" style={{ fontSize: '16px' }}>
							{loadingMessage}
						</span>
					</div>
					{showSuccess && (
						<div className="text-center text-success">
							<div className="d-flex align-items-center justify-content-center gap-2">
								<svg
									style={{ width: '16px', height: '16px' }}
									fill="currentColor"
									viewBox="0 0 20 20"
								>
									<path
										fillRule="evenodd"
										d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
										clipRule="evenodd"
									/>
								</svg>
								<span>{successMessage}</span>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
}
